import type { SupplierVendorNexAliasGroup } from '../hooks/useGetSettings';
import {
    mergeInvoiceAliasesIntoVendorNexAliasMappings,
    type MergeVendorNexAliasMappingsResult,
} from './mergeVendorNexAliasMappings';
import { resolveSupplierForVendorAliasSave } from './resolveSupplierByNexVendorId';

export async function prepareInvoiceVendorAliasMappingsSave(params: {
    mappings: SupplierVendorNexAliasGroup[];
    nexVendorName: string;
    invoiceAliasTexts: string[];
    supplierId?: string | null;
    supplierTitle?: string | null;
    nexVendorId?: number;
    sessionId: string;
}): Promise<MergeVendorNexAliasMappingsResult> {
    const nexVendorName = params.nexVendorName.trim();
    if (!nexVendorName) return { ok: false, reason: 'no_supplier_group' };

    let supplierId = (params.supplierId ?? '').trim();
    let supplierTitle = (params.supplierTitle ?? '').trim();

    const initial = mergeInvoiceAliasesIntoVendorNexAliasMappings({
        mappings: params.mappings,
        supplierId: supplierId || undefined,
        nexVendorName,
        invoiceAliasTexts: params.invoiceAliasTexts,
    });
    if (initial.ok) return initial;

    if (supplierId && !supplierTitle) {
        const fromMapping = params.mappings.find((g) => g.supplierId === supplierId);
        supplierTitle = fromMapping?.supplierTitle?.trim() ?? '';
    }

    if (!supplierId || !supplierTitle) {
        const resolved = await resolveSupplierForVendorAliasSave(params.sessionId, {
            supplierId: supplierId || undefined,
            nexVendorId: params.nexVendorId,
        });
        if (resolved) {
            supplierId = supplierId || resolved._id;
            supplierTitle = supplierTitle || resolved.title;
        }
    }

    if (supplierId && !supplierTitle) {
        supplierTitle = nexVendorName;
    }

    if (!supplierId || !supplierTitle) {
        return { ok: false, reason: 'no_supplier_group' };
    }

    return mergeInvoiceAliasesIntoVendorNexAliasMappings({
        mappings: params.mappings,
        supplierId,
        nexVendorName,
        invoiceAliasTexts: params.invoiceAliasTexts,
        ensureGroup: {
            supplierId,
            supplierTitle,
            nexVendorId: params.nexVendorId,
        },
    });
}
